import React, { Fragment, Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Toast } from 'view/common';
import { history } from 'store';
import cx from 'classnames';
import {
  Header, Welcome, ProjectsList, Project, Landing,
} from 'view/screens';
import actions from './duck/actions';

const loggedIn = true; // ovveride when auth is implemented

const ProtectedRoute = ({ path, component, exact }) => (
  loggedIn
    ? <Route exact={exact} path={path} component={component} />
    : <Redirect to="/" />
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    props.checkIsDark();
  }

  componentDidUpdate() {
    const { isDarkTheme } = this.props;
    document.body.className = isDarkTheme ? 'dark' : '';
  }

  render() {
    const { isDarkTheme } = this.props;
    if (isDarkTheme === null) return <div />;
    return (
      <div className={cx({ dark: isDarkTheme })}>
        <ConnectedRouter history={history}>
          <Fragment>
            <Toast />
            <Header />
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route exact path="/welcome" component={Welcome} />
              <ProtectedRoute path="/project/:id" component={Project} />
              <ProtectedRoute path="/projects" component={ProjectsList} />
            </Switch>
          </Fragment>
        </ConnectedRouter>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

const mapDispatchToProps = dispatch => ({
  checkIsDark: () => dispatch(actions.checkIsDark()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/view/App.js